import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

@Injectable()
export class MyfireService {
  getUserFromDataBase(uid) {
    const ref = firebase.database().ref('users/' + uid);
    return ref.once('value').then(snapshot => snapshot.val());
  }
  constructor() {}
  getUrl() {
    return 'https://us-central1-nkpoliklinika-38938.cloudfunctions.net/terminPodsetnik?';
  }
  getEmail() {
    return 'https://us-central1-nkpoliklinika-38938.cloudfunctions.net/sendMail?';
  }
  deleteDan(id) {
    firebase
      .database()
      .ref('danas')
      .child(id)
      .remove();
  }
}
